export enum RouteUrl {
    Home = "/",

    Login = "/login",

    Dashboard = "/dashboard",
    DashboardOverview = "/dashboard/overview",
    DashboardCompare = "/dashboard/compare",
    DashboardTeamComparison = "/dashboard/teamcomparison",
    DashboardAnalytics = "/dashboard/analytics",
    DashboardHeatMap = "/dashboard/heatmap",
    DashboardPeriodData = "/dashboard/period-data",

    TournamentAnalysis = "/tournament",
    TournamentOverview = "/tournament/overview",
    TournamentCompare = "/tournament/compare",
    TournamentRanking = "/tournament/ranking",
    TournamentPlayers = "/tournament/players",
    TournamentMatches = "/tournament/goalkeepers",
    TournamentLines = "/tournament/lines",

    Scouting = "/scouting",
    ScoutingPlayers = "/scouting/players",
    ScoutingGoalkeepers = "/scouting/goalkeepers",
    ScoutingFollowed = "/scouting/followed",

    Players = "/players",
    PlayerProfile = "/player",

    Settings = "/settings",
    SettingsMultiplier = "/settings/multiplier",
    SettingsReport = "/settings/report",
    SettingsNotifications = "/settings/notifications",
    SettingsAdmin = "/settings/admin",

    Leaderboards = "/leaderboards",

    Kpis = "/kpis",
    KpisCurrent = "/kpis/current",
    KpisDefault = "/kpis/default",

    Chat = "/chat",

    PrivacyPolicy = "/privacy-policy",
    SystemStatus = "/system-status",

    Teams = "/teams",
}
